export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';



// WEBPACK FOOTER //
// ./js/actions/changeLanguage.js